import { QuerySnapshot, DocumentData } from "firebase/firestore";
import { updateIntoIdbAndUpdateView } from "../../firestore/get-appointments";
import getB from "../bridges/EkaBridge";
import { FirebaseAppointment, OfflineAppointment } from "../../firestore/types";
import { getIdb } from "../bridges/methods";
import { firebaseAppointmentToOfflineAppointment } from "./firebase-appointment-to-offline-appointment";

export default async function onAptSnapshot(
  snapshot: QuerySnapshot<DocumentData, DocumentData>
) {
  const aids = new Set<string>();
  snapshot.forEach((doc) => aids.add(doc.id));

  if (snapshot.metadata.fromCache && !snapshot.metadata.hasPendingWrites) {
    console.log("🚀 Firestore", new Date(), "From cache", { aids });
    return;
  }

  console.log("🚀 Firestore", new Date(), "From server", { aids });

  const existingAppointments = await getIdb()
    .appointments.where("aid")
    .anyOf(Array.from(aids))
    .toArray();

  console.log("🚀 Firestore", new Date(), "Existing appointments", {
    existingAppointments,
  });

  const existingAids = new Set(existingAppointments.map((item) => item.aid));
  const nonExistingAids = Array.from(aids).filter(
    (aid) => !existingAids.has(aid)
  );

  console.log("🚀 Firestore", new Date(), "Non existing appointments", {
    nonExistingAids,
  });

  const shouldFetchPtDir =
    nonExistingAids.length > 0 ||
    getB()?.getMe()?.user?.["b-id"] === "76527282322352";

  if (shouldFetchPtDir) {
    const toFetchPatientList: string[] = [];
    snapshot.forEach((doc) => {
      if (
        nonExistingAids.includes(doc.id) ||
        getB()?.getMe()?.user?.["b-id"] === "76527282322352"
      ) {
        toFetchPatientList.push(doc.data().patient_oid);
      }
    });
    await getB().fetchPatientListFromServer(toFetchPatientList);
  }

  const documentChanges = snapshot.docChanges();

  console.log("🚀 Firestore", new Date(), "Document changes length", {
    documentChangesLength: documentChanges.length,
  });
  console.log("🚀 Firestore", new Date(), "Document changes", {
    documentChanges,
  });

  const aptsList: OfflineAppointment[] = [];
  const toDeleteAptList: string[] = [];

  const cloneNonExistingAids = new Set([...nonExistingAids]);

  documentChanges.forEach((changes) => {
    console.log("🚀 Firestore", new Date(), "Changes", { changes });
    const isRemoved = changes.type === "removed";
    const doc = changes.doc;

    cloneNonExistingAids.delete(doc.id);

    if (isRemoved) {
      console.log("🚀 Firestore", new Date(), "Removed", { docId: doc.id });
      toDeleteAptList.push(doc.id);
      return;
    }

    const offlineApt: OfflineAppointment =
      firebaseAppointmentToOfflineAppointment(doc.id, doc);

    aptsList.push(offlineApt);
  });

  if (cloneNonExistingAids.size > 0) {
    console.log(
      "🚀 Firestore",
      new Date(),
      "Non existing appointments left over, handling from snapshots",
      { nonExistingAids: Array.from(cloneNonExistingAids) }
    );
    for (let i = 0; i < snapshot.docs.length; i++) {
      const doc = snapshot.docs[i];
      if (cloneNonExistingAids.has(doc.id)) {
        const apt = doc.data() as FirebaseAppointment;
        console.log("🚀 Firestore, dumping from snapshot", new Date(), "Apt", {
          apt,
        });
        const offlineApt: OfflineAppointment =
          firebaseAppointmentToOfflineAppointment(doc.id, doc);
        aptsList.push(offlineApt);
      }
    }
  }

  await updateIntoIdbAndUpdateView(aptsList, toDeleteAptList);
}
